export const unifyTeamCode = (code) => {
  const renamedTeamCodes = {
    DWG: 'DK',
  }

  return renamedTeamCodes[code] || code
}
